import { Font, StyleSheet } from '@react-pdf/renderer';

Font.register({
  family: 'Lato',
  fonts: [
    { src: '/Lato-Regular.ttf', fontWeight: 400 },
    { src: '/Lato-Bold.ttf', fontWeight: 700 },
  ],
});

export const styles = StyleSheet.create({
  page: {
    position: 'relative',
    flexDirection: 'row',
    fontFamily: 'Lato',
    paddingHorizontal: 30,
    paddingTop: 20,
    width: '100%',
    height: '100%',
  },
  leftColumn: {
    width: '44%',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    gap: 25,
  },
  imageColumnWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: 25,
  },
  imageLeft1: {
    width: 300,
    height: 410,
    objectFit: 'cover',
    borderRadius: 15,
  },
  imageLeft2: {
    width: 300,
    height: 320,
    objectFit: 'cover',
    borderRadius: 15,
  },
  imageRight1: {
    width: 300,
    height: 440,
    objectFit: 'cover',
    borderRadius: 15,
  },
  imageRight2: {
    width: 300,
    height: 240,
    objectFit: 'cover',
    borderRadius: 15,
  },
  rightColumn: {
    width: '56%',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    paddingLeft: 30,
    paddingTop: 200,
    height: '100%',
  },
  eventImage: {
    height: 440,
    width: 700,
    objectFit: 'contain',
    paddingLeft: 60,
  },
  textWrapper: {
    width: '100%',
    height: '100%',
    paddingLeft: 45,
  },
  title: {
    color: '#27343d',
    fontFamily: 'Lato',
    fontSize: 26,
    fontWeight: 400,
    textAlign: 'left',
    marginTop: 20,
    marginLeft: 20,
    width: '70%',
  },
  subtitle: {
    color: '#27343d',
    fontFamily: 'Lato',
    fontSize: 20,
    fontWeight: 400,
    textAlign: 'left',
    marginTop: 30,
    marginLeft: 20,
    width: '80%',
  },
});
